import { useMemo } from 'react';
import { isAtLeastVersion, isNativeShell, nativeAppVersion } from '../services/exports/NativeApp';
import { MinNativeVersion } from '../services/exports/Constants';

export default function useNativeApp() {
  // Both signals are fixed for the page's lifetime, so this never needs to recompute.
  return useMemo(() => {
    const version = nativeAppVersion();

    return {
      version,
      isNativeShell: isNativeShell(),
      supportsPrinterBridge: isAtLeastVersion(version, MinNativeVersion.PrinterBridge),
    };
  }, []);
}
